var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bs" }, [
    _c("footer", [
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "wrapper" },
          [
            _c("div", { staticClass: "footer__logo mb-4 mt-2" }, [
              _c("img", {
                attrs: {
                  src: _vm.$asset.image("brand/logo-xl.svg"),
                  alt: "g-portal-logo",
                },
              }),
            ]),
            _vm._v(" "),
            _vm._l(_vm.groupedFooterBlocks, function (ref) {
              var sectionsKey = ref[0]
              var sections = ref[1]
              return _c(
                "div",
                { key: sectionsKey, staticClass: "footer__grid pb-4" },
                _vm._l(
                  Object.entries(_vm.footerLinks).filter(function (ref) {
                    var key = ref[0]

                    return sections.includes(key)
                  }),
                  function (ref) {
                    var sectionKey = ref[0]
                    var section = ref[1]
                    return _c(
                      "div",
                      { key: sectionKey, staticClass: "footer__col" },
                      [
                        _c("strong", [_vm._v(_vm._s(section.title))]),
                        _vm._v(" "),
                        sectionKey === "language"
                          ? [_c("region-switcher")]
                          : [
                              _c(
                                "ul",
                                _vm._l(section.children, function (link, i) {
                                  return _c(
                                    "li",
                                    { key: i },
                                    [
                                      link.link
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: link.link,
                                                  target: link.external
                                                    ? "_blank"
                                                    : "_self",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(link.title) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : [
                                            link.action
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "javascript:void(0)",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.runFooterAction(
                                                            link.action
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(link.title) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "footer__address",
                                                    },
                                                    [_vm._v(_vm._s(link.title))]
                                                  ),
                                                ],
                                          ],
                                    ],
                                    2
                                  )
                                }),
                                0
                              ),
                            ],
                      ],
                      2
                    )
                  }
                ),
                0
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "footer__terms" }, [
              _c("div", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.footerLinks.copyright) +
                    "\n\n            "
                ),
                _c("div", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("footer:footer.terms")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }